export default __webpack_public_path__ + "static/media/colony erased.c5f2abb8.jpg";